
import React from 'react';
import { ShoppingBag, ExternalLink, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BuyerProfile {
  id: string;
  full_name: string | null;
  phone_number: string | null;
  email: string | null;
}

interface BuyerDetailsProps {
  buyerProfile: BuyerProfile | null;
  onViewProfile: (buyerId: string) => void;
  onContactBuyer: () => void;
}

const BuyerDetails = ({ buyerProfile, onViewProfile, onContactBuyer }: BuyerDetailsProps) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md">
      <h4 className="font-medium text-sm mb-2 flex items-center">
        <ShoppingBag className="h-3.5 w-3.5 mr-1.5" />
        Detajet e Blerësit
      </h4>
      <div className="flex items-center justify-between">
        <p className="text-sm">
          {buyerProfile?.full_name || 'Blerës i panjohur'}
        </p>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            size="sm"
            className="flex items-center gap-1 text-xs"
            onClick={() => buyerProfile?.id && onViewProfile(buyerProfile.id)}
          >
            <ExternalLink size={14} />
            Shiko Profilin
          </Button>
          <Button 
            variant="default" 
            size="sm"
            className="bg-brand-500 hover:bg-brand-600 flex items-center gap-1 text-xs"
            onClick={onContactBuyer}
          >
            <Mail size={14} />
            Kontakto
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BuyerDetails;
